import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription, fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ViewportService implements OnDestroy {
  private readonly mobileBreakpoint = 575.98;
  private readonly isMobileSubject = new BehaviorSubject<boolean>(this.getIsMobile());
  private resizeSubscription: Subscription;

  readonly isMobile$ = this.isMobileSubject.asObservable();

  constructor(private ngZone: NgZone) {
    if (typeof window === 'undefined') {
      return;
    }

    this.ngZone.runOutsideAngular(() => {
      this.resizeSubscription = fromEvent(window, 'resize').pipe(
        debounceTime(100)
      ).subscribe(() => {
        const isMobile = this.getIsMobile();

        if (isMobile !== this.isMobileSubject.value) {
          this.ngZone.run(() => this.isMobileSubject.next(isMobile));
        }
      });
    });
  }

  ngOnDestroy(): void {
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
  }

  isMobile(): boolean {
    return this.isMobileSubject.value;
  }

  isDesktop(): boolean {
    return !this.isMobile();
  }

  private getIsMobile(): boolean {
    if (typeof window === 'undefined') {
      return false;
    }

    return window.innerWidth <= this.mobileBreakpoint;
  }
}
